import type { RefObject } from 'react';

type ModalBaseProps = {
    title?: React.ReactNode;
    children: React.ReactNode;
    open: boolean;
    onClose: () => void;
    onClosed?: () => void;
    initialFocusRef?: RefObject<HTMLDivElement | null>;
    panelClassName?: string;
};

type DefaultModalProps = ModalBaseProps & {
    variant?: 'default';
};

export type SidebarModalProps = ModalBaseProps & {
    variant: 'sidebar';
    side?: 'left' | 'right';
    width?: string;
};

export type ModalProps = DefaultModalProps | SidebarModalProps;

export const ModalVariant = {
    DEFAULT: 'default',
    SIDEBAR: 'sidebar',
} as const;

export type ModalVariantType = (typeof ModalVariant)[keyof typeof ModalVariant];
